module.exports = __webpack_public_path__ + "static/img/logo_16@2x.6d3156f8.png";